import { useState } from "react";
import { trackEvent } from "@hopper-b2b/api";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import {
  DisruptionTrackingEvents,
  FintechProductType,
} from "@hopper-b2b/types";
import {
  ActionLink,
  IconComponent,
  IconName,
  MobilePopoverCard,
  TermsAndConditions,
} from "@hopper-b2b/ui";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import styles from "./MissedConnectionDisclaimerModal.module.scss";

export interface IMissedConnectionDisclaimerModalProps {
  open: boolean;
  onClose: () => void;
}

export const MissedConnectionDisclaimerModal = ({
  open,
  onClose,
}: IMissedConnectionDisclaimerModalProps) => {
  const { t } = useI18nContext();
  const [openTerms, setOpenTerms] = useState(false);

  const handleOpenTerms = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setOpenTerms(true);
    trackEvent({
      eventName: DisruptionTrackingEvents.TAP_DELAY_TERMS,
      properties: undefined,
    });
  };

  return (
    <>
      <MobilePopoverCard
        className={styles.MissedConnectionDisclaimerModal}
        contentClassName={styles.MissedConnectionDisclaimerModalContent}
        open={open}
        onClose={onClose}
        headerElement={
          <Typography
            className="mobile-flight-details-modal-header"
            variant="h4"
          >
            <span className="title">
              {t("missedConnectionInfoPopup.header")}
            </span>
            <ActionLink
              className="filter-close-button"
              content={
                <IconComponent
                  ariaLabel={t("modalClose.ariaLabel")}
                  className={clsx("close-button-icon")}
                  name={IconName.Close}
                />
              }
              label={t("modalClose.label")}
              onClick={onClose}
            />
          </Typography>
        }
      >
        <div className="content">
          <div className="description">
            {t("missedConnectionInfoPopup.description")}
          </div>
          <div className="details">
            <div className="details-content">
              {t("missedConnectionInfoPopup.details")}
            </div>
            <div className="details-terms">
              <Trans
                i18nKey="missedConnectionInfoPopup.terms"
                components={[
                  <span
                    className={styles.MissedConnectionDisclaimerModalTermsCta}
                    onClick={(e) => {
                      handleOpenTerms(e);
                    }}
                    role="button"
                    tabIndex={0}
                    aria-label={t("termsAndConditions")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleOpenTerms(e);
                      }
                    }}
                  />,
                ]}
              />
            </div>
          </div>
        </div>
      </MobilePopoverCard>
      <TermsAndConditions
        productType={FintechProductType.MissedConnection}
        open={openTerms}
        onClose={() => setOpenTerms(false)}
      />
    </>
  );
};
